import { errorConstants } from '../constants';

export const errorActions = {
    update,
    reset
};

function update(err) {
  let open = err.open;
  let code = err.code;
  let message = err.message;
  let tokenExpired = code===401 || code ===403;
  return {
    type: errorConstants.UPDATE,
    error: {open, code, message, tokenExpired}
  };
}

function reset() {
    return {
      type: errorConstants.RESET,
      error: {open: false, code: 200, message: "", tokenExpired: false} };
}



// WEBPACK FOOTER //
// ./src/actions/errorDisplay.actions.js